import { CloudinaryImage_File, Maybe } from 't2-graphql-types';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';
import { AuthorDetailContainer } from '../ArticleHeader/AuthorDetailContainer';
import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';
import { T2ProfileCardContainer } from '../ProfileCard/T2ProfileCardContainer';
import { UnstyledTooltip } from '../Tooltip/UnstyledTooltip';
import { PROFILE_CARD_HOVER_DELAY } from '../ProfileCard/constants';

export type TArticleAuthorLinkProps = {
  name: string;
  username: string;
  profileImage: TCloudinaryImageShape;
  author: {
    id?: Maybe<string>;
    name?: Maybe<string>;
    username?: Maybe<string>;
    profileImage?: Maybe<CloudinaryImage_File>;
  };
};

export const ArticleAuthorLink = ({ author }: TArticleAuthorLinkProps) => {
  const { sendEvent } = useAnalytics();

  const onArticleAuthorClick = () => {
    sendEvent('post_author_click');
  };

  return (
    <UnstyledTooltip
      direction="right"
      floatingUIHover={PROFILE_CARD_HOVER_DELAY}
      trigger={
        <AuthorDetailContainer
          name={author?.name || ''}
          username={author?.username || ''}
          profileImage={author?.profileImage as TCloudinaryImageShape}
          onClick={onArticleAuthorClick}
        />
      }
    >
      <T2ProfileCardContainer id={author?.id as string} />
    </UnstyledTooltip>
  );
};
